import { render, staticRenderFns } from "./GerenciamentoPreco.vue?vue&type=template&id=110ab9b4"
import script from "./GerenciamentoPreco.vue?vue&type=script&lang=js"
export * from "./GerenciamentoPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports